<template>
  <router-view />
</template>


<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 0px;
  padding: 0px;
}

body {
  display: block;
  margin: 0;
}

:root {
  --app-color-primary: #F26522;
  --primary-color: #F26522;
  --primary-color-lighten: #F26522;
}
</style>
